import React from "react";
import "./TermsOfUse.css";
import DefaultLayout from "../../layouts/DefaultLayout";

const Privacy = () => {
  return (
    <>
      <DefaultLayout>
        <div>
          <div className="termsofuse-container">
            <div className="termsofuse-section">
              <div className="termsofuse-header">
                <h5 className="termsofuse-h5">PRIVACY</h5>
              </div>

              <div className="document-section">
                <div className="termsofuse-document">
                  <h5 className="document-heading">
                  Privacy Policy
                  </h5>
                </div>


                <div>
                  <h5 className="effective-document-h5">1. Introduction</h5>
                  <p className="effective-document-p">
                  Dear OVestor, this privacy policy has been created to give clear explanations
                   on how your information (including any confidential personal information) is
                    being collected, used, disclosed and protected.
This policy applies to the information collected when you use the OVest OVest website and mobile
 application. This privacy policy is subject to change from time to time. If changes are made, 
 you will be notified by revising the date at the top of this policy, and in some cases, you may
  be provided with additional notice (such as adding a statement to the homepages of OVest OVestbsite 
  or mobile application or by sending via an email notification).
You are encouraged to review the privacy policy regularly to stay informed about OVest information
 practices and the ways you can help protect your privacy. This privacy policy applies to the Services 
 provided by OVest.

                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2. Collection of Information</h5>
                  <h5 className="effective-document-h5">2.1 Categories of Confidential Personal Information</h5>
                  <p className="effective-document-p">
                  Confidential personal information is collected when you apply for an OVest account or when you make enquiries about your OVest account. The information may include your name, address, phone number, 
                  email address, date of birth, bank account information, BVN, username, password, and next of kin details.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2.2 Information About Your Transactions On OVest</h5>
                  <p className="effective-document-p">
                 Whenever you perform financial transactions on your OVest account, confidential personal information is collected in connection with each transaction, including transaction time, the amount, and merchant details.
                  Details of Pictures, memos or other information that you attach to your transactions may also be collected. 
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2.3 Information From Other Sources</h5>
                  <p className="effective-document-p">
                  When you create an OVest account, information, including confidential personal information about you may be collected from non-affiliated third party service providers 
                  in order to verify your identity and for fraud prevention, including your prior addresses and names.s
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2.4 Other Information collected by OVest</h5>
                  <p className="effective-document-p">
                  Any information you provide may be collected, such as your name, email address and any other information you choose to provide. 
                  For example, such information may be collected if you request an invite to join OVest or if you enter
                   into any contest or promotional offer.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2.5 Information Collected Automatically from the Services you enjoy on OVest</h5>
                  <p className="effective-document-p">
                  When you access different Services on OVest, information about you are automatically 
                  collected as follows:
                  </p>
                  <p className="effective-document-p">
                  1.	Log Information: Information about your usage of Services on OVest are logged, including the type of browser you use, access times, 
                  pages vieOVestd, your IP address and the page you visited before navigating to using OVest Services.
                  </p>
                  <p className="effective-document-p">
                  2.	Device Information: Information about the computer or mobile device you use to access OVest Services are collected, including 
                  the hardware model, operating system and version, unique device identifiers and mobile network information.
                  </p>
                  <p className="effective-document-p">
                  3.	Location Information: Your location information may be collected from your mobile device with your prior consent. Also, Google Maps have been incorporated into OVest Services, and you may consent to the collection of location information by Google Maps in connection with your use of this maps service. Any information collected via your use of Google Maps will be transmitted directly to Google and is not collected by OVest. Please refer to Google’s privacy policy for details about their collection, use and sharing of this information. For information about how 
                  to disable the collection of location information from your device, please see “Your Choices” (5.3) below.
                  </p>
                  <p className="effective-document-p">
                  4.	Information Collected by Cookies and Other Tracking Technologies: These various technologies are used to collect information on OVest Services and other OVestbsites, and this may include sending cookies to your computer or mobile device. Cookies are small data files stored on your hard drive or in device memory that help OVest to improve the Services rendered and your experience, see which areas and features of OVest Services are popular and count visits. For more information about cookies, and how to disable them, please see “Your Choices” (5) below. Information using OVestb beacons (also known as "tracking pixels") may also be collected. OVestb beacons are electronic images that may be used in OVest Services or emails and help deliver cookies, count visits, 
                  understand usage and campaign effectiveness and determine whether an email has been opened and acted upon.
                  </p> 
                  <p className="effective-document-p">
                  5.	How Do Not Track Signals Are Responded to: Do Not Track browser configurations are alloOVestd by OVest. Cookies and other tracking technologies are used, and Do Not Track status may alter the available services with certain browsers, when these tracking functionalities are used to provide services. The information OVest applications attempt to collect based on your Do Not Track configuration are not altered.
                    The app does use third party services that may collect information used to identify you. Links to privacy policy of third party service providers used by the app:
                    <p className="effective-document-p">●	Google Play Services</p>    
                    <p className="effective-document-p">●	AdMob</p> 
                    <p className="effective-document-p"> ●	Firebase Analytics</p>
                    <p className="effective-document-p"> ●	Fabric</p> 
                    <p className="effective-document-p">●	Crashlytics</p>  
                    <p className="effective-document-p"> ●	Adjust</p>  
                    <p className="effective-document-p">●	Facebook</p>  
                  </p> 
                </div>
                <div>
                  <h5 className="effective-document-h5">
                  2.6 Information OVest receive from other sources
                  </h5>
                  <p className="effective-document-p">
                  OVest work closely with third parties (including financial service providers, security agencies, etc). You will be notified when OVest 
                  receive information about you from them and the purposes for which OVest intend to use that information.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  3. Use of Information
                  </h5>
                  <p className="effective-document-p">
                  OVest may use your information, including confidential personal information as follows:
<p  className="effective-document-p"> ●	Provide, maintain and improve the Services you enjoy</p>
<p  className="effective-document-p"> ●	Provide and deliver the products and services you request, process transactions 
    and send you related information, including confirmations.</p>
<p  className="effective-document-p">  ●	Verify your identity and prevent fraud. </p>
<p  className="effective-document-p"> ●	Send you technical notices, updates, security alerts and support and administrative messages.</p> 
<p  className="effective-document-p">●	Respond to your comments, questions and requests and provide customer service. </p>  
<p  className="effective-document-p">  ●	Communicate with you about products, services, offers, promotions, rewards, and events 
    offered by OVest and others, and provide news and information that are thought to be of interest to you. </p>
<p  className="effective-document-p"> ●	Monitor and analyze trends, usage and activities in connection with OVest Services.</p> 
<p  className="effective-document-p"> ●	Personalize and improve the Services and provide advertisements, content or features that 
    match user profiles or interests.</p> 
<p  className="effective-document-p">  ●	Process and deliver contest or promotion entries and rewards. </p>
<p  className="effective-document-p"> ●	Link or combine with information OVest get from others to help understand your needs and 
    provide you with better service.</p> 
<p  className="effective-document-p"> ●	Carry out any other purpose for which the information was collected. </p> 
<p  className="effective-document-p">OVest is based in Nigeria and the information collected is governed by the Nigerian law. 
    By accessing or using the Services or otherwise providing information to OVest, you consent to the 
    processing and transfer of information in and to Nigeria and other countries.</p>  


                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  4. Disclosure of Information
                  </h5>
                  <p className="effective-document-p">
                  Any information collected about current and former customers may be disclosed, 
                  including confidential personal information, to affiliates and non-affiliated third parties as follows:
                  </p>
                  <p className="effective-document-p">
                  1.	With financial service providers, including the financial institutions identified 
                  in your cardholder bank agreement that provide banking services in connection with your OVest account.
                  </p>
                  <p className="effective-document-p">
                  2.	With another user, when you sign up for OVest's services via a referral link. The user that referred you may receive information indicating 
                  that you have enrolled with OVest. You may avoid this sharing by not using a referral link to enroll.
                  </p>
                  <p className="effective-document-p">
                  3.	With non-financial companies, such as email service providers that perform marketing services on behalf of OVest,
                   and fraud prevention service providers that use the information to provide services to OVest and other companies.
                  </p>
                  <p className="effective-document-p">
                  4.	With a non-affiliated third-party to access and transmit your personal and financial information from a relevant financial institution. You grant the third-party the right, poOVestr, 
                  and authority to access and transmit this information according to the terms of their privacy policy.
                  </p>
                  <p className="effective-document-p">
                  With other non-affiliated companies for OVest everyday business purposes, such as to process transactions, maintain accounts, respond to court orders and legal investigations or report to credit bureaus. For example, 
                  in connection with OVest everyday business purposes, OVest may share information about you as follows:
                  </p>
                  <p className="effective-document-p">
                  1.	In response to a request for information, if OVst is required 
                  by, or OVest believe disclosure is in accordance with, any applicable law, regulation or legal process.
                  </p>
                  <p className="effective-document-p">
                  2.	With relevant law enforcement officials or other 
                   third parties, such as investigators or auditors, if OVest believe it is appropriate to investigate fraud.
                  </p>
                  <p className="effective-document-p">
                  3.	If OVest believe your actions are inconsistent with the spirit or language 
                  of OVest user agreements or policies, or to protect the rights, property and safety of OVest or others.
                  </p>
                  <p className="effective-document-p">
                  3.	If OVest believe your actions are inconsistent with the spirit or language 
                  of OVest user agreements or policies, or to protect the rights, property and safety of OVest or others.
                  </p>
                  <p className="effective-document-p">
                  4.	In connection with, or during negotiations of, any merger, 
                  sale of OVest's assets, financing or acquisition of all or a portion of the business to another company; and
                  </p>
                  <p className="effective-document-p">
                  5.	With your consent or at your direction, including if you are notified 
                  that the information you provide will be shared in a particular manner and you provide such information.
                  </p>
                  <p className="effective-document-p">
                  OVest may also share aggregated or de-identified Information, which cannot reasonably be used to identify you. For example, OVest may share transaction zip codes with third parties to 
                  improve accuracy in geo-locating transactions and to improve the clarity of transaction descriptions.
                  </p>
                  <p className="effective-document-p">
                  OVest will usually not share your personal information with other third parties without your consent. 
                  Where OVest need to transfer your data to another country, OVest shall ensure that such country to which 
                  the data is being transferred shall have adequate data protection law. OVest will 
                  seek your consent where OVest need to send your data to a country without an adequate data protection law.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  5. Your Choices
                  </h5>
                  <h5 className="effective-document-h5">
                  5.1 Account Information
                  </h5>
                  <p className="effective-document-p">
                  You may edit your account profile information by logging into your account via OVest Services. If you wish to delete or deactivate your online account, please contact OVest, 
                  but note that OVest may retain certain information as required by law or for legitimate business purposes.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  5.2 Promotional Communications
                  </h5>
                  <p className="effective-document-p">
                 You may opt out of receiving promotional emails and text messages from OVest by following the instructions in those messages. Please note that if you opt out, OVest may still send you transactional 
                 or relationship messages, such as those about your account or any ongoing business relations.
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">
                  5.3 Location Information
                  </h5>
                  <p className="effective-document-p">
                  If you initially consent to the collection of location information by OVest or Google Maps within OVest mobile application, you may be able to subsequently stop this collection through your device operating system settings or through your online account settings. If either of these opt-out options are not available to you, you may also disable location 
                  information by following the standard uninstall process to remove our mobile application from your device.
                  </p>
                </div>
                 <div>
                  <h5 className="effective-document-h5">
                  5.4 Cookies
                  </h5>
                  <p className="effective-document-p">
                  Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set 
                  your browser to remove or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of OVest Services.
                  </p>
                </div> 
                <div>
                  <h5 className="effective-document-h5">
                  5.5 Social Sharing Features
                  </h5>
                  <p className="effective-document-p">
                  OVest Services include social sharing features for common social networks to let users share content. These features are served from third-party services that may serve their own cookies. The use of such features enables the sharing of information with your friends or the public, depending on the settings you establish with the entity that provides the social sharing feature. For more information about the purpose and scope of data collection and processing in connection with 
                  social sharing features, please visit the privacy policies of the entities that provide these features.
                  </p>
                </div> <div>
                  <h5 className="effective-document-h5">
                  5.6 Analytics and Advertising Services Provided by Others
                  </h5>
                  <p className="effective-document-p">
                  OVest may allow others to provide analytics service and to serve advertisements on across the Internet on behalf of OVest. These entities may use cookies, web beacons and other technologies to collect information about your use of the Services and other websites, including your IP address, web browser, pages viewed, time spent on pages, links clicked and conversion information. This information may be used by OVest and others, to, among other things, analyze and track data, determine the popularity of 
                  certain content, deliver advertising targeted to your interests and better understand your online activity.
                  </p>
                </div> <div>
                  <h5 className="effective-document-h5">
                  6. Your Rights
                  </h5>
                  <p className="effective-document-p">
                  The law gives you certain rights in respect of the information OVest hold about you. Below is a highlight of some of 
                  those rights. It is not a complete, exhaustive statement of your rights in respect of your personal data:
                  </p>
               <p className="effective-document-p">1.	You have a right to consent to 
                   this Privacy Policy and to withdraw your consent at any time. </p>   
<p className="effective-document-p">2.	You have a right to a copy of the personal data OVest hold about you, 
    as well as the information about what OVest do with it, who OVest share 
    it with and how long OVest hold it for. OVest may make a reasonable charge 
    for additional copies of that data in the case of unfounded and excessive requests.</p> 
<p className="effective-document-p"> 3.	You have a right to freely transfer your data received from OVest to any other person. </p>
<p className="effective-document-p">  4.	You have the right to have the information OVest hold about you corrected, 
    if it is factually inaccurate. You may contact OVest for this purpose.</p>
<p className="effective-document-p"> 5.	In some circumstances, you have the right to the deletion of the information 
    that OVest hold about you.</p>
<p className="effective-document-p"> 6.	You have a right to lodge a complaint about the handling of your personal information 
    with the National Information Technology Development Agency (NITDA).</p>
<p className="effective-document-p"> 7.	You have the right to ask OVest not to process your personal data for marketing purposes. 
    OVest will usually inform you (before collecting your data) if OVest intend to use your data 
    for such purposes or if OVest intend to disclose your information to any third party for such purposes.</p>
<p className="effective-document-p">NITDA’s website has a wealth of useful information in respect of your rights over your personal data.</p>
<p className="effective-document-p">If you wish to exercise your rights, you may write to OVest at hello@OVest.com</p>
                </div>

                 <div>
                  <h5 className="effective-document-h5">
                  7. Security
                  </h5>
                  <p className="effective-document-p">
                  OVest takes reasonable measures to help protect all information about you from loss, theft, misuse and 
                  unauthorized access, disclosure, alteration and destruction. Additionally, OVest implements policies 
                  designed to protect the confidentiality and security of your confidential personal information, 
                  including a privacy protection policy. OVest limits access to your confidential personal information 
                  to employees that have a business reason to know such information, and implement security practices 
                  and procedures designed to protect the confidentiality and security of such 
                  information and prohibit unlawful disclosure of such information in accordance with its policies.
                  </p>
                  <p className="effective-document-p">Where you have chosen a password that allows you to access certain parts of the website and mobile 
                      application, you are responsible for keeping this password confidential. OVest advise you not to 
                      share your password with anyone. OVest have also taken measures to comply with provision of security 
                      facilities for the protection of your confidential personal information through the set up of firewalls, 
                      limited access to specified authorized individuals, encryption and continuous capacity building for relevant personnel. OVest therefore have digital 
                      and physical security measures to limit and eliminate possibilities of data privacy breach incidents.</p>
                      <p className="effective-document-p">Although OVest use appropriate security measures once OVest have received your personal information, 
                          the transmission of data over the internet (including by email) is never completely secure. OVest endeavour
                           to protect personal information, but OVest cannot guarantee the security of data transmitted. 
                          You will be notified and any applicable regulator of a breach where OVest are legally required to do so.</p>
                </div> 
                <div>
                  <h5 className="effective-document-h5">
                  8. Where OVest store your Data
                  </h5>
                  <p className="effective-document-p">
                  The data that OVest collect from you will be transferred to and stored at a destination outside Nigeria. 
                  By submitting your personal data, you agree to this transfer, storing or processing. OVest will take all 
                  steps reasonably necessary to ensure that your data is treated securely and in accordance with this 
                  privacy policy. All information you provide to us is stored on our secure cloud storage solution.
                  </p>
                  <p  className="effective-document-p">Your personal 
                      information will not be retained for longer than is necessary for the purposes for 
                      which it was processed.</p>
                </div> 
                <div>
                  <h5 className="effective-document-h5">
                  9. How long OVest keep your personal information
                  </h5>
                  <p className="effective-document-p">
                  OVest will hold your personal information on OVest’s systems for as long as is necessary to fulfill 
                  the purpose for which it was collected or to comply with legal, regulatory or internal policy requirements.
                  </p>
                </div> 
                <div>
                  <h5 className="effective-document-h5">
                  Contact Us
                  </h5>
                  <p className="effective-document-p">
                  If you have any questions about this Privacy Policy, please contact OVest at:
                  </p>
                </div> <div>
                  <h5 className="effective-document-h5">
                  OVest Attention: Compliance Officer
                  </h5>
                  <p className="effective-document-p">
                  1, Majaro Street, Ajibade Bus-stop, Mokola, Ibadan 
                  <p> {" "}
                    <a href="mailto:hello@myovest.com">
                      hello@myovest.com.
                    </a> </p>
                  </p>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};

export default Privacy;
